export const CLEAR_LIST = "CLEAR_LIST";
export const LOGGED_OUT = "LOGGED_OUT";
